import { Box, Container, Grid, useTheme } from '@mui/material'
import MenuCategories from 'components/MenuCategoryTabs/MenuCategories'
import MenuItemCardList from 'components/MenuItemCardList'
import ConfirmationDialog from 'components/Modal/ConfirmationDialog/ConfirmationDialog'
import NewOrderItemPanel from 'components/NewOrderPanel'
import OrderCustomerInfo from 'components/OrderCustomerInfo'
import OrderHeader from 'components/OrderHeader'
import OrderPanel from 'components/OrderPanel'
import POSHeader from 'components/POSHeader'
import { ORDER_TYPES, useOrder } from 'context/OrderContext'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ThemeProvider } from 'theme/ThemeContext2'

const AddItemToOrderContainer = ({ orderDetails,
    menuItems, categories, activeCategory, setActiveCategory, searchQuery, setSearchQuery,
    isFetchingItems, isLoading
}) => {
    const navigate = useNavigate();
    const [openConfirm, setOpenConfirm] = useState(false);
    const { setOrderType, orderItems, customerData, addItemToOrder, removeItemFromOrder, resetOrder } = useOrder();
    const theme = useTheme();

    useEffect(() => {
        setOrderType(ORDER_TYPES.DINE_IN);
    }, [setOrderType]);

    
    const handleBack = () =>{
        if(orderItems?.length > 0){
            setOpenConfirm(true);
        } else{
            navigate(-1);
        }
    }
    
    const handleCloseCancel = () => {
        setOpenConfirm(false);
    }

    const handleConfirm = () => {
        setOpenConfirm(false);
        resetOrder();
        navigate(-1);
    }

    return (
        <ThemeProvider>
            <Box className='order-listing' sx={{ bgcolor: "#fff", minHeight: "100vh", display: "flex", flexDirection: "column" }}>
                <POSHeader />
                <Container
                    maxWidth={false}
                    disableGutters
                    sx={{
                        // px: { xs: 1, sm: 2, md: 3 },
                        padding: '0px',
                        maxWidth: "1400px",
                        mx: "auto",
                    }}
                >
                    <Box sx={{ padding: '30px 50px' }}>
                        <Box sx={{ mb: 2 }}>
                            <OrderHeader title={"Back to Order"} orderId={orderDetails?.order_id} handleBack={handleBack} />
                        </Box>
                        <Grid container spacing={{ xs: 1, sm: 2 }}>
                            <Grid item xs={12} lg={8.5}>
                                <Box>
                                    <Box sx={{ mb: 3 }}>
                                        <OrderCustomerInfo orderDetails={orderDetails} paymentVisible={false} orderStatusVisible={false} variant="compact" />
                                    </Box>
                                    <Box>
                                        <MenuCategories
                                            categories={categories}
                                            activeCategory={activeCategory}
                                            onCategoryChange={setActiveCategory}
                                            isLoading={isLoading}
                                        />

                                        <MenuItemCardList
                                            items={menuItems}
                                            searchQuery={searchQuery}
                                            onSearchChange={setSearchQuery}
                                            isLoading={isFetchingItems}
                                            // onAddItem={handleAddItem}
                                        />
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={12} lg={3.5}>
                                <Box>
                                    <NewOrderItemPanel orderDetails={orderDetails}/>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>
            </Box>

            
            <ConfirmationDialog
                open={openConfirm}
                handleClose={handleCloseCancel}
                handleConfirm={handleConfirm}
                isLoading={isLoading}
                action="Discard Changes"
                btnText="Discard Changes"
                infoText="You have added items in the cart which is not saved for the order. Going back will discard the changes. Are you sure you want to discard the changes?"
            />
        </ThemeProvider>
    )
}

export default AddItemToOrderContainer
